import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-azgaar-map-generator-info',
    templateUrl: './azgaar-map-generator-info.component.html',
    styleUrls: ['./azgaar-map-generator-info.component.scss'],
    standalone: false
})
export class AzgaarMapGeneratorInfoComponent {
  constructor(public activeModal: NgbActiveModal) { }

  close() {
    this.activeModal.close();
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }
}
